<template>
    <div>
        <b-tabs v-model="activeTab">
            <b-tab title="Сотрудники">
                <Users v-if="activeTab === 0"/>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import Users from './Users/Users';
export default {
    name: "AdminPanel",
    components: {
        Users
    },
    data() {
        return {
            activeTab: 0
        }
    }
}
</script>

<style scoped>

</style>